import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { findServiceBySlug, findCityBySlug } from '../data/locationServices';
import '../styles/location.scss';

const LocationService = () => {
  const { serviceSlug, citySlug } = useParams();
  const service = findServiceBySlug(serviceSlug);
  const city = findCityBySlug(citySlug);

  if (!service || !city) {
    return (
      <div className="page location-service">
        <section className="section">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12 mono">
                <p>Page not found.</p>
                <Link to="/studio">Back to studio</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  const title = `${service.name} in ${city.name} – Heretic Studio`;
  const description = `Heretic Studio is an independent UX and web design studio working with clients in ${city.name} and across the UK. We specialise in ${service.name.toLowerCase()} for startups and small businesses, helping teams ship user-focused digital products and websites.`;

  return (
    <>
      <Seo
        title={title}
        description={description}
        ogTitle={title}
        ogDescription={description}
        index
      />
      <div className="page location-service">
        <section className="section hero">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <h1>{service.name} in {city.name}</h1>
                
              </div>
            </div>
          </div>
        </section>

        <section className="section intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-3">
                <span className="mono">{service.name}</span>
              </div>
              <div className="col-2" />
              <div className="col-7">
                <div className="large light">
                  {service.heading}
                </div>
                <p className="" style={{ marginTop: '1.5rem' }}>
                  Based in the UK and working remotely, Heretic Studio supports founders, operators and small teams in {city.name}
                  with strategy, UX and interface design, and web builds. The focus is on practical, shippable work rather than
                  vanity design — helping you move from idea to something people can actually use.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section content">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-3">
                <span className="mono">How we can help</span>
              </div>
              <div className="col-2" />
              <div className="col-7">
                <ul className="" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li>Discovery, user journeys and UX foundations</li>
                  <li>Wireframes, prototypes and design systems</li>
                  <li>Marketing sites and product UI design</li>
                  <li>Design and build for new products and MVPs</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="section content">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-3">
                <span className="mono">Next steps</span>
              </div>
              <div className="col-2" />
              <div className="col-7">
                <p className="">
                  If you&apos;re looking for {service.name.toLowerCase()} support in {city.name}, you can start with a quick email
                  outlining your project, timeline and budget. We&apos;ll respond with honest feedback on fit and possible ways to
                  work together.
                </p>
                <Link to="/contact" className="mono">
                  Contact Heretic Studio
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LocationService;
